import { useState } from 'react';
import { steppedRound } from '~/src/utils';

export const useSteppedNumber = (init: number, step: number) => {
  const [state, _setState] = useState(init);
  const setState = (v: number) => _setState(steppedRound(v, step));
  return [state, setState, _setState] as const;
};
